import { render, staticRenderFns } from "./EditPromoter.component.vue?vue&type=template&id=82300c18"
import script from "./EditPromoter.component.vue?vue&type=script&lang=ts"
export * from "./EditPromoter.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports